import TableDynamic from "../../../components/TableDynamic";
import React from "react";
import { Button } from "react-bootstrap";
import { store } from "../../../reducer/Store";
import ApiService from "../../../services/ApiService";
import ModalFormRegisterOrUpdate from "../../../components/ModalFormRegisterOrUpdate";
const MerchandisingPlv = ({ refreshTab }) => {
  const { dispatch, state } = React.useContext(store);
  const [showAddCustomerPlv, setShowAddCustomerPlv] = React.useState(false);
  const [showUpdateCustomerPlv, setShowUpdateCustomerPlv] =
    React.useState(false);
  const [customerPlv, setCustomerPlv] = React.useState("");
  const [customerPlvQuantityMax, setCustomerPlvQuantityMax] = React.useState(1);
  const [customerPlvId, setCustomerPlvId] = React.useState("");
  const [customerPlvManufacturing, setCustomerPlvManufacturing] =
    React.useState(0);
  const [customerPlvPassing, setCustomerPlvPassing] = React.useState(0);

  const columnsName = [
    "Liste des PLV",
    "Quantité max",
    "Fabrication PLV",
    "Passage prestataire",
    "",
  ];
  const columns = [
    "operation_plv_type",
    "quantity_max",
    "manufacturing",
    "passing",
    "updateAndDelete",
  ];

  const handleClose = () => {
    setShowAddCustomerPlv(false);
    setShowUpdateCustomerPlv(false);
    setCustomerPlv();
    setCustomerPlvQuantityMax(1);
    setCustomerPlvId("");
    setCustomerPlvManufacturing(0);
    setCustomerPlvPassing(0);
  };
  const handleShow = () => setShowAddCustomerPlv(true);

  /**
   * Cette fonction gère la mise à jour des informations d'un type de PLV pour un client spécifique. Elle met à jour les états correspondant aux différentes propriétés du type de PLV, telles que la quantité maximale, l'identifiant, la fabrication, le passage et le type de PLV lui-même. Elle affiche également le formulaire de mise à jour correspondant.
   * @param { Object } cPlv - Le type de PLV pour lequel les informations doivent être mises à jour.
   */
  const handleUpdateCustomerPlv = (cPlv) => {
    setCustomerPlvQuantityMax(cPlv.quantity_max);
    setCustomerPlvId(cPlv.id);
    setCustomerPlvManufacturing(cPlv.manufacturing);
    setCustomerPlvPassing(cPlv.passing);
    setCustomerPlv(cPlv.operation_plv_type.id);
    setShowUpdateCustomerPlv(true);
  };

  /**
   * Cette fonction récupère toutes les opérations merchandising pour tous les marques d'un client donné pour l'année en cours. Elle met à jour le state de l'application avec les opérations récupérées.
   */
  const getAllOperationsAllbrands = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operations-by-customer-year-lighter/${state.dataSelectedClient.id}/${
        JSON.parse(localStorage.getItem("currentYear")).value
      }`,
      "get"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        const operationsForMerch = response.data;
        dispatch({
          type: "SET_OPERATIONSFORMERCHANDISING",
          payload: operationsForMerch,
        });
        //console.log(operationsForMerch, "All operations all brands");
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        console.log(error);
        dispatch({ type: "SET_LOADER", payload: false });
      });
  };

  /**
   * Cette fonction récupère la liste des PLV d'un client en fonction de son ID.
   * @param { Number } customerId - L'identifiant du client dont on veut récupérer la liste des PLV.
   */
  const getCustomerPlv = async (customerId) => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-plvs-by-customer-year/${customerId}/${
        JSON.parse(localStorage.getItem("currentYear")).value
      }`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_LISTCUSTOMERPLV",
          payload: response.data,
        });
        //console.log(response.data);
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction ajoute une nouvelle opération de PLV pour un client donné, avec les informations fournies par l'utilisateur dans le formulaire.
   * @param { Number } customerPlvQuantityMax - Nombre de plv maximum à disposer chez le client.
   * @param { Boolean } customerPlvPassing - Détermine si un prestataire doit venir l'installer.
   * @param { Number } customerPlv - L'id du PLV.
   * @param { Boolean } customerPlvManufacturing - Détermine si le PLV est déjà fabriqué.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   * @param { Number } state.dataCustomer.id - L'id du client sélectionné.
   */
  const addCustomerPlv = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    await ApiService.request(
      {
        customer_id: state.dataCustomer.id,
        year_id: state.currentYear.value,
        operation_plv_type_id: customerPlv,
        quantity_max: customerPlvQuantityMax,
        passing: customerPlvPassing,
        manufacturing: customerPlvManufacturing,
      },
      "operation-plvs",
      "post"
    )
      .then(function () {
        handleClose();
        dispatch({ type: "SET_LOADER", payload: false });
        getCustomerPlv(state.dataCustomer.id);
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction permet de mettre à jour les informations d'une PLV d'un client existant.
   * Si une ou plusieurs opérations en cours utilisent l'ancienne quantité maximum de cette PLV, un message de confirmation s'affiche pour demander à l'utilisateur s'il souhaite mettre à jour ces opérations avec la nouvelle quantité maximum.
   * @param { Number } customerPlvQuantityMax - Nombre de plv maximum à disposer chez le client.
   * @param { Boolean } customerPlvPassing - Détermine si un prestataire doit venir l'installer.
   * @param { Number } customerPlv - L'id du PLV.
   * @param { Boolean } customerPlvManufacturing - Détermine si le PLV est déjà fabriqué.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   * @param { Number } state.dataCustomer.id - L'id du client sélectionné.
   * @param { Number } customerPlvId - L'id du PLV à mettre à jour.
   */
  const updateCustomerPlv = async () => {
    var message = "";
    message = state.operationsForMerch.some((elt) =>
      elt.operation_plv_value.some(
        (opePlvValue) =>
          opePlvValue.operation_plv_id ===
          state.listCustomerPlv.filter((elt) => elt.id === customerPlvId)[0].id
      )
    )
      ? "Êtes-vous sûr de vouloir changer la quantité max de ce PLV ? Une ou des opérations en cours utilisent l'ancienne valeur, ils vont être mis à jour avec la nouvelle quantité maximum s'ils la dépassent."
      : "";
    if ((message && window.confirm(message)) || message === "") {
      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request(
        {
          customer_id: state.dataCustomer.id,
          operation_plv_type_id: customerPlv,
          quantity_max: customerPlvQuantityMax,
          passing: customerPlvPassing,
          manufacturing: customerPlvManufacturing,
        },
        "operation-plvs/" + customerPlvId,
        "put"
      )
        .then(function () {
          handleClose();
          dispatch({ type: "SET_LOADER", payload: false });
          getCustomerPlv(state.dataCustomer.id);
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette fonction met à jour le statut d'un PLV d'un client dans la liste des PLVs du client.
   * @param {Object} currentValues - Les valeurs courantes du PLV à mettre à jour.
   * @param {String} passingOrManufacturing - Indique s'il s'agit de mettre à jour le statut de passage ou de fabrication du PLV.
   */
  const updateFromListCustomerPlv = async (
    currentValues,
    passingOrManufacturing
  ) => {
    if (window.confirm("Etes vous sûr de mettre à jour le statut ?")) {
      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request(
        {
          customer_id: state.dataCustomer.id,
          operation_plv_type_id: currentValues.operation_plv_type.id,
          quantity_max: currentValues.quantity_max,
          passing:
            passingOrManufacturing === "passing"
              ? currentValues.passing === 0
                ? 1
                : 0
              : currentValues.passing,
          manufacturing:
            passingOrManufacturing === "manufacturing"
              ? currentValues.manufacturing === 0
                ? 1
                : 0
              : currentValues.manufacturing,
        },
        "operation-plvs/" + currentValues.id,
        "put"
      )
        .then(function () {
          dispatch({ type: "SET_LOADER", payload: false });
          getCustomerPlv(state.dataCustomer.id);
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette fonction supprime un type de PLV pour un client spécifique.
   * @param {Object} cPlv - Le type de PLV à supprimer.
   */
  const deleteCustomerPlv = async (cPlv) => {
    if (
      window.confirm(
        "Êtes vous sûr de vouloir supprimer au client le type de PLV " +
          cPlv.name +
          " ?"
      )
    ) {
      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request({}, "operation-plvs/" + cPlv.id, "delete")
        .then(function () {
          dispatch({ type: "SET_LOADER", payload: false });
          getCustomerPlv(state.dataCustomer.id);
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette fonction récupère la liste des types de PLV disponibles pour l'année en cours, avec des informations plus légères pour une utilisation plus rapide. Les résultats sont stockés dans le store Redux sous forme de liste d'objets.
   */
  const getAllTypesPlvLighter = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-plv-types-by-year-lighter/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        //console.log(response.data);
        dispatch({
          type: "SET_LISTTYPESPLV",
          payload: response.data,
        });
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  React.useEffect(() => {
    if (state.dataSelectedClient && state.dataSelectedClient.id) {
      getAllOperationsAllbrands();
      getAllTypesPlvLighter();
      getCustomerPlv(state.dataSelectedClient.id);
    }
  }, [state.dataSelectedClient, state.currentYear.value, refreshTab]);

  return (
    <>
      {showAddCustomerPlv && (
        <ModalFormRegisterOrUpdate
          show={showAddCustomerPlv}
          registerOrUpdate={addCustomerPlv}
          dataTypePlv={state.listTypesPlv}
          dataCustomerPlv={state.listCustomerPlv}
          customerPlv={customerPlv}
          setCustomerPlv={setCustomerPlv}
          qtyMax={customerPlvQuantityMax}
          setQuantityMax={setCustomerPlvQuantityMax}
          customerPlvManufacturing={customerPlvManufacturing}
          setCustomerPlvManufacturing={setCustomerPlvManufacturing}
          customerPlvPassing={customerPlvPassing}
          setCustomerPlvPassing={setCustomerPlvPassing}
          handleClose={handleClose}
          controlFormId={"add-customer-plvs"}
        />
      )}

      {showUpdateCustomerPlv && (
        <ModalFormRegisterOrUpdate
          show={showUpdateCustomerPlv}
          registerOrUpdate={updateCustomerPlv}
          dataTypePlv={state.listTypesPlv}
          dataCustomerPlv={state.listCustomerPlv}
          qtyMax={customerPlvQuantityMax}
          customerPlv={customerPlv}
          setCustomerPlv={setCustomerPlv}
          setQuantityMax={setCustomerPlvQuantityMax}
          customerPlvManufacturing={customerPlvManufacturing}
          setCustomerPlvManufacturing={setCustomerPlvManufacturing}
          customerPlvPassing={customerPlvPassing}
          setCustomerPlvPassing={setCustomerPlvPassing}
          handleClose={handleClose}
          controlFormId={"update-customer-plvs"}
        />
      )}
      <div className="position-relative mt-5">
        {(parseInt(localStorage.getItem("user_role")) !== 5 &&
          parseInt(localStorage.getItem("user_role")) !== 6) && (
          <Button
            onClick={handleShow}
            className="button-add is-top-right btn btn-primary"
          >
            Ajouter une PLV
          </Button>
        )}
        <TableDynamic
          columnsName={columnsName}
          columns={columns}
          showUpdate={handleUpdateCustomerPlv}
          data={state.listCustomerPlv}
          updateState={updateFromListCustomerPlv}
          deleteD={deleteCustomerPlv}
        ></TableDynamic>
        {(parseInt(localStorage.getItem("user_role")) !== 5 &&
          parseInt(localStorage.getItem("user_role")) !== 6) && (
          <Button
            onClick={handleShow}
            className="button-add is-bottom-right btn btn-primary"
          >
            Ajouter une PLV
          </Button>
        )}
      </div>
    </>
  );
};

export default MerchandisingPlv;
